import { render } from "./SingleEditorCard.vue?vue&type=template&id=0263834a"
import script from "./SingleEditorCard.vue?vue&type=script&lang=js"
export * from "./SingleEditorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__